// Definición modular de las 6 MISIONES de Planeta Suma.
// Cada misión es una aventura independiente con su propia destreza de suma.
// Los ejercicios se generan dinámicamente cada vez que se juega (ver MathEngine.generateMissionSet).

import { rnd } from '../math/operations';

export const CHALLENGES_PER_MISSION = 10;

export const SUMA_MISSIONS = [
  {
    index: 0,
    num: 1,
    name: 'Planeta 1',
    skill: 'Suma: 1 dígito + 1 dígito',
    desc: 'Suma dos números de un dígito, del 0 al 9.',
    type: 'single',
    time: 90,
  },
  {
    index: 1,
    num: 2,
    name: 'Planeta 2',
    skill: 'Suma: 2 dígitos, sin reagrupación',
    desc: 'Suma números de 2 dígitos sin reagrupación.',
    type: 'two_no_regroup',
    time: 100,
  },
  {
    index: 2,
    num: 3,
    name: 'Planeta 3',
    skill: 'Suma: 2 dígitos, con reagrupación',
    desc: 'Suma números de 2 dígitos con reagrupación (llevando).',
    type: 'two_regroup',
    time: 110,
  },
  {
    index: 3,
    num: 4,
    name: 'Planeta 4',
    skill: 'Suma: 3 dígitos, sin reagrupación',
    desc: 'Suma números de 3 dígitos sin reagrupación.',
    type: 'three_no_regroup',
    time: 120,
  },
  {
    index: 4,
    num: 5,
    name: 'Planeta 5',
    skill: 'Suma: 3 dígitos, con reagrupación',
    desc: 'Suma números de 3 dígitos con reagrupación (llevando).',
    type: 'three_regroup',
    time: 130,
  },
  {
    index: 5,
    num: 6,
    name: 'Planeta 6',
    skill: 'Suma: destrezas mixtas',
    desc: 'Combina todas las destrezas de suma anteriores.',
    type: 'mixed',
    time: 140,
  },
];

// ¿Sumar a+b requiere alguna reagrupación (llevar) en cualquier posición?
function hasCarry(a, b) {
  let x = a;
  let y = b;
  while (x > 0 || y > 0) {
    if ((x % 10) + (y % 10) >= 10) return true;
    x = Math.floor(x / 10);
    y = Math.floor(y / 10);
  }
  return false;
}

function twoDigitNoRegroup() {
  const ta = rnd(1, 8);
  const tb = rnd(1, 9 - ta); // decenas no llevan
  const ua = rnd(0, 9);
  const ub = rnd(0, 9 - ua); // unidades no llevan
  return { a: ta * 10 + ua, b: tb * 10 + ub };
}

function twoDigitRegroup() {
  let a;
  let b;
  do {
    a = rnd(10, 99);
    b = rnd(10, 99);
  } while (!hasCarry(a, b));
  return { a, b };
}

function threeDigitNoRegroup() {
  const ha = rnd(1, 8);
  const hb = rnd(1, 9 - ha);
  const ta = rnd(0, 9);
  const tb = rnd(0, 9 - ta);
  const ua = rnd(0, 9);
  const ub = rnd(0, 9 - ua);
  return { a: ha * 100 + ta * 10 + ua, b: hb * 100 + tb * 10 + ub };
}

function threeDigitRegroup() {
  let a;
  let b;
  do {
    a = rnd(100, 999);
    b = rnd(100, 999);
  } while (!hasCarry(a, b));
  return { a, b };
}

const GENERATORS = {
  single: () => ({ a: rnd(0, 9), b: rnd(0, 9) }),
  two_no_regroup: twoDigitNoRegroup,
  two_regroup: twoDigitRegroup,
  three_no_regroup: threeDigitNoRegroup,
  three_regroup: threeDigitRegroup,
};

// Devuelve {a, b} para el tipo de misión indicado.
export function genAddition(type) {
  if (type === 'mixed') {
    const keys = Object.keys(GENERATORS);
    return GENERATORS[keys[rnd(0, keys.length - 1)]]();
  }
  return (GENERATORS[type] || GENERATORS.single)();
}
